module.exports = __webpack_public_path__ + "static/media/fukuanliucheng.e26ba51b.png";